import { get, post, put, Delete } from "../axios";

// 学习任务-列表
export const studyTaskList = (params) =>
  get("/web/study/task/list", params);

// 学习任务-新增
export const studyTaskAdd = (params) =>
  post("/web/study/task/add", params);

// 学习任务-删除
export const studyTaskDelete = (id) =>
  Delete("/web/study/task/delete/" + id, "");

// 学习任务-编辑
export const studyTaskUpdate = (params) =>
  put("/web/study/task/update", params);

// 学习任务-状态编辑
export const studyTaskStateUpdate = (params) =>
  put("/web/study/task/state/update", params);

// 学习任务-全部数据（用于编辑回显）
export const studyTaskListAll = () =>
  get("/web/study/task/listAll");

/**
 * 获取学习任务详情数据
 * @param {string|number} id - 学习任务 ID
 * @returns {Promise} 详情接口的 Axios Promise 响应
 */
export const studyTaskDetail = (id) =>
  get("/web/study/task/view/" + id);
